/* tslint:disable */
/* eslint-disable */
/**
 * Y-Sports backend-next Management API
 * Composed management-facing contract for `backend-next`. This spec is an aggregation layer over module-scoped contracts and should reference canonical module definitions instead of copying them. 
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AdminPlayerStats
 */
export interface AdminPlayerStats {
    /**
     * 
     * @type {string}
     * @memberof AdminPlayerStats
     */
    playerId: string;
    /**
     * 
     * @type {string}
     * @memberof AdminPlayerStats
     */
    personId: string;
    /**
     * 
     * @type {string}
     * @memberof AdminPlayerStats
     */
    playerName: string;
    /**
     * 
     * @type {number}
     * @memberof AdminPlayerStats
     */
    birthYear?: number | null;
    /**
     * 
     * @type {string}
     * @memberof AdminPlayerStats
     */
    email?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AdminPlayerStats
     */
    sportCode: string;
    /**
     * 
     * @type {string}
     * @memberof AdminPlayerStats
     */
    preferredPosition?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof AdminPlayerStats
     */
    activeTeamNames: Array<string>;
    /**
     * 
     * @type {number}
     * @memberof AdminPlayerStats
     */
    officialMatchesPlayed: number;
    /**
     * 
     * @type {number}
     * @memberof AdminPlayerStats
     */
    participationHistoryMatchesPlayed: number;
    /**
     * 
     * @type {number}
     * @memberof AdminPlayerStats
     */
    totalMatchesPlayed: number;
    /**
     * 
     * @type {number}
     * @memberof AdminPlayerStats
     */
    attendedTrainingSessions: number;
    /**
     * 
     * @type {number}
     * @memberof AdminPlayerStats
     */
    totalTrainingSessions: number;
    /**
     * 
     * @type {number}
     * @memberof AdminPlayerStats
     */
    trainingAttendanceRate: number;
    /**
     * 
     * @type {Date}
     * @memberof AdminPlayerStats
     */
    lastPlayedAt?: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof AdminPlayerStats
     */
    lastTrainingAttendanceAt?: Date | null;
}

/**
 * Check if a given object implements the AdminPlayerStats interface.
 */
export function instanceOfAdminPlayerStats(value: object): value is AdminPlayerStats {
    if (!('playerId' in value) || value['playerId'] === undefined) return false;
    if (!('personId' in value) || value['personId'] === undefined) return false;
    if (!('playerName' in value) || value['playerName'] === undefined) return false;
    if (!('sportCode' in value) || value['sportCode'] === undefined) return false;
    if (!('activeTeamNames' in value) || value['activeTeamNames'] === undefined) return false;
    if (!('officialMatchesPlayed' in value) || value['officialMatchesPlayed'] === undefined) return false;
    if (!('participationHistoryMatchesPlayed' in value) || value['participationHistoryMatchesPlayed'] === undefined) return false;
    if (!('totalMatchesPlayed' in value) || value['totalMatchesPlayed'] === undefined) return false;
    if (!('attendedTrainingSessions' in value) || value['attendedTrainingSessions'] === undefined) return false;
    if (!('totalTrainingSessions' in value) || value['totalTrainingSessions'] === undefined) return false;
    if (!('trainingAttendanceRate' in value) || value['trainingAttendanceRate'] === undefined) return false;
    return true;
}

export function AdminPlayerStatsFromJSON(json: any): AdminPlayerStats {
    return AdminPlayerStatsFromJSONTyped(json, false);
}

export function AdminPlayerStatsFromJSONTyped(json: any, ignoreDiscriminator: boolean): AdminPlayerStats {
    if (json == null) {
        return json;
    }
    return {
        
        'playerId': json['playerId'],
        'personId': json['personId'],
        'playerName': json['playerName'],
        'birthYear': json['birthYear'] == null ? undefined : json['birthYear'],
        'email': json['email'] == null ? undefined : json['email'],
        'sportCode': json['sportCode'],
        'preferredPosition': json['preferredPosition'] == null ? undefined : json['preferredPosition'],
        'activeTeamNames': json['activeTeamNames'],
        'officialMatchesPlayed': json['officialMatchesPlayed'],
        'participationHistoryMatchesPlayed': json['participationHistoryMatchesPlayed'],
        'totalMatchesPlayed': json['totalMatchesPlayed'],
        'attendedTrainingSessions': json['attendedTrainingSessions'],
        'totalTrainingSessions': json['totalTrainingSessions'],
        'trainingAttendanceRate': json['trainingAttendanceRate'],
        'lastPlayedAt': json['lastPlayedAt'] == null ? undefined : (new Date(json['lastPlayedAt'])),
        'lastTrainingAttendanceAt': json['lastTrainingAttendanceAt'] == null ? undefined : (new Date(json['lastTrainingAttendanceAt'])),
    };
}

export function AdminPlayerStatsToJSON(json: any): AdminPlayerStats {
    return AdminPlayerStatsToJSONTyped(json, false);
}

export function AdminPlayerStatsToJSONTyped(value?: AdminPlayerStats | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'playerId': value['playerId'],
        'personId': value['personId'],
        'playerName': value['playerName'],
        'birthYear': value['birthYear'],
        'email': value['email'],
        'sportCode': value['sportCode'],
        'preferredPosition': value['preferredPosition'],
        'activeTeamNames': value['activeTeamNames'],
        'officialMatchesPlayed': value['officialMatchesPlayed'],
        'participationHistoryMatchesPlayed': value['participationHistoryMatchesPlayed'],
        'totalMatchesPlayed': value['totalMatchesPlayed'],
        'attendedTrainingSessions': value['attendedTrainingSessions'],
        'totalTrainingSessions': value['totalTrainingSessions'],
        'trainingAttendanceRate': value['trainingAttendanceRate'],
        'lastPlayedAt': value['lastPlayedAt'] == null ? value['lastPlayedAt'] : value['lastPlayedAt'].toISOString(),
        'lastTrainingAttendanceAt': value['lastTrainingAttendanceAt'] == null ? value['lastTrainingAttendanceAt'] : value['lastTrainingAttendanceAt'].toISOString(),
    };
}

